// Angular
import { Component, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// RxJS
import { filter } from 'rxjs';
// Modules
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
// Components
import { FreeSearchComponent } from '../../../partsearch-shared-module/free-search/free-search.component';

@Component({
  selector: 'app-search-panel',
  templateUrl: './search-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, FreeSearchComponent],
})
export class SearchPanelComponent implements OnInit {
  // Private
  private router = inject(Router);
  activeOffcanvas = inject(NgbActiveOffcanvas);
  private readonly destroyRef = inject(DestroyRef);

  /**
   * On Init
   * @memberof SearchPanelComponent
   */
  ngOnInit(): void {
    // Close quick panel if route changed
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((event: any) => {
      this.activeOffcanvas.close();
    });
  }
}
